import { CodeInjectionPreset } from '@/types/codeInjection';

/**
 * Apply theme mode adjustments to a preset
 * Currently only adjusts menuItemTextRest color from white to black in light mode
 * Designed to be easily extensible for future theme-aware properties
 */
export function applyThemeToPreset(
  preset: CodeInjectionPreset, 
  themeMode: 'light' | 'dark' = 'dark'
): CodeInjectionPreset {
  // If dark mode or no menuItemTextRest settings, return preset unchanged
  if (themeMode === 'dark' || !preset.globalSettings?.menuItemTextRest) {
    return preset;
  }

  // Check if preset has white text that needs adjustment for light mode
  if (preset.globalSettings.menuItemTextRest.color === '#ffffff' && themeMode === 'light') {
    return {
      ...preset,
      globalSettings: {
        ...preset.globalSettings,
        menuItemTextRest: {
          ...preset.globalSettings.menuItemTextRest,
          color: '#141414' // Black text for light mode
        }
      }
    };
  }

  // Future theme adjustments can be added here
  // Example:
  // if (preset.globalSettings.someOtherProperty === 'someValue' && themeMode === 'light') {
  //   // Apply light mode adjustment
  // }

  return preset;
}